var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "schedule-flow__viewing",
      attrs: {
        "data-vv-scope": "flowViewing",
        id: "plannerFrom",
        action: _vm.route,
        method: "POST"
      }
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "property_id" },
        domProps: { value: _vm.property.id }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "subscription_id" },
        domProps: { value: _vm.subscription.id }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "appointment_id" },
        domProps: { value: _vm.appointmentId }
      }),
      _vm._v(" "),
      _c("h2", { staticClass: "section-title" }, [
        _vm._v(
          _vm._s(
            _vm.locales.appointments &&
              _vm.locales.appointments.schedule_viewing
          )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-10" }, [
        _c("div", { staticClass: "theme-table__heading" }, [
          _c("h3", { staticClass: "theme-table__title" }, [
            _vm._v(
              _vm._s(
                _vm.locales.appointments &&
                  _vm.locales.appointments.guests_and_monthly_income
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "theme-btn theme-btn--text",
              attrs: { href: _vm.editRoute }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales.common && _vm.locales.common.edit_your_profile
                  ) +
                  "\n        "
              ),
              _c("i", { staticClass: "icon-go-right" })
            ]
          )
        ]),
        _vm._v(" "),
        _vm.subscription && _vm.subscription.tenants
          ? _c("div", { staticClass: "theme-table__wrap mb-5" }, [
              _c("table", { staticClass: "theme-table" }, [
                _c(
                  "tbody",
                  _vm._l(_vm.subscription.tenants, function(user, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(user.fullNameWithTitle))]),
                      _vm._v(" "),
                      _c("td", [_vm._v("€ " + _vm._s(user.income))])
                    ])
                  }),
                  0
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "theme-alert theme-alert--info" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "theme-alert__text" }, [
            _vm._v(
              _vm._s(
                _vm.locales.appointments &&
                  _vm.locales.appointments.you_need_prove_income
              ) + "\n      "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-9" },
        [
          _c("functional-calendar", {
            staticClass: "single-calendar",
            attrs: { configs: _vm.calendarConfigs },
            on: { choseDay: _vm.handleDateChange },
            scopedSlots: _vm._u([
              {
                key: "datePickerInput",
                fn: function(props) {
                  return [
                    _c(
                      "theme-input",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        attrs: {
                          label:
                            _vm.locales.appointments &&
                            _vm.locales.appointments.choose_date,
                          placeholder:
                            _vm.locales.common &&
                            _vm.locales.common.choose_date,
                          value: _vm.dateComputed,
                          name: "date",
                          "valid-scope": "flowViewing",
                          isExtraInfo: true,
                          isReadonly: true
                        }
                      },
                      [
                        _c("template", { slot: "extra-info" }, [
                          _c("i", { staticClass: "icon-calendar" })
                        ])
                      ],
                      2
                    )
                  ]
                }
              }
            ]),
            model: {
              value: _vm.date,
              callback: function($$v) {
                _vm.date = $$v
              },
              expression: "date"
            }
          }),
          _vm._v(" "),
          _c(
            "theme-select",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "`required`"
                }
              ],
              attrs: {
                label:
                  _vm.locales.appointments &&
                  _vm.locales.appointments.choose_time,
                placeholder:
                  _vm.locales.common && _vm.locales.common.choose_time,
                disabled: !_vm.dateComputed,
                name: "time",
                "valid-scope": "flowViewing",
                value: _vm.time,
                options: _vm.timeOptions,
                isExtraInfo: true
              },
              on: { change: _vm.handleTimeChange }
            },
            [
              _c("template", { slot: "extra-info" }, [
                _c("i", { staticClass: "icon-time" })
              ])
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex flex-col lg:flex-row gap-4 items-start lg:items-center"
        },
        [
          _c(
            "a",
            {
              staticClass: "theme-btn theme-btn--theme",
              class: {
                "theme-btn--theme-disabled": !_vm.dateComputed || !_vm.time
              },
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                }
              }
            },
            [_vm._v(_vm._s(_vm.locales.common && _vm.locales.common.continue))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "theme-alert theme-alert--notice" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "theme-alert__text" }, [
              _vm._v(
                _vm._s(
                  _vm.locales.appointments &&
                    _vm.locales.appointments.you_will_be_notified
                ) + "\n      "
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "theme-alert__icon" }, [
      _c("i", { staticClass: "icon-notice" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "theme-alert__icon" }, [
      _c("i", { staticClass: "icon-notice" })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b41ae46", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b41ae46","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ScheduleFlowViewing.vue
// module id = 695
// module chunks = 1